export default __webpack_public_path__ + "static/illustration-content-title.url-93bd7920bd3ffd790d5f61bc0bb17751.svg";